/* Opora store waitlist popup — show after 10s, bottom-mid */
(function () {
  var root = document.querySelector('[data-oss]');
  if (!root) return;

  /* v7 — exclusive + professional human rewrite */
  var KEY = 'opora_store_signup_dismissed_v7';
  var TTL_MS = 14 * 24 * 60 * 60 * 1000;
  var DELAY_MS = 10000;

  function forceShow() {
    try {
      return new URLSearchParams(window.location.search).get('show_store_signup') === '1';
    } catch (e) {
      return false;
    }
  }

  function dismissed() {
    if (forceShow()) return false;
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return false;
      var ts = parseInt(raw, 10);
      if (!ts) return true;
      return Date.now() - ts < TTL_MS;
    } catch (e) {
      return false;
    }
  }

  function markDismissed() {
    if (forceShow()) return;
    try {
      localStorage.setItem(KEY, String(Date.now()));
    } catch (e) {}
  }

  function previewBarHeight() {
    var selectors = [
      '#PreviewBarButtonContainer',
      '#PBarNextFrameWrapper',
      '.preview-bar__container',
      '[data-preview-bar]',
      'iframe#preview-bar-iframe'
    ];
    var h = 0;
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (!el) continue;
      var rect = el.getBoundingClientRect();
      if (rect && rect.height > h) h = rect.height;
    }
    /* Shopify often injects a fixed bottom bar ~52–64px even if selectors differ */
    if (!h && /preview_theme_id=/.test(location.search)) h = 56;
    return h;
  }

  function placeAboveChrome() {
    var lift = previewBarHeight();
    var base = 22;
    root.style.bottom = 'max(' + (base + lift) + 'px, calc(env(safe-area-inset-bottom, 0px) + ' + (18 + lift) + 'px))';
  }

  function hide() {
    root.classList.remove('is-on');
    root.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      root.hidden = true;
      root.setAttribute('hidden', '');
    }, 380);
    markDismissed();
  }

  function show() {
    if (dismissed()) return;
    placeAboveChrome();
    root.hidden = false;
    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');
    /* double rAF so opacity transition actually runs after display flips */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.add('is-on');
      });
    });
  }

  var closeBtn = root.querySelector('[data-oss-close]');
  if (closeBtn) closeBtn.addEventListener('click', hide);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-on')) hide();
  });

  window.addEventListener('resize', function () {
    if (root.classList.contains('is-on')) placeAboveChrome();
  });

  if (root.querySelector('.oss__success')) {
    placeAboveChrome();
    root.hidden = false;
    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');
    root.classList.add('is-on');
    markDismissed();
    window.setTimeout(hide, 4500);
    return;
  }

  if (dismissed()) return;

  window.setTimeout(show, forceShow() ? 400 : DELAY_MS);
})();
